import { SET_NOTIFICATIONS_PAGE } from "../actions/notificationActions";

export default function(
  state = { ws: new WebSocket(`${process.env.REACT_APP_WS_URL}`) },
  action
) {
  let { payload, type } = action;
  switch (type) {
    case SET_NOTIFICATIONS_PAGE:
      return { ...state, [payload.page]: payload.data };
      break;
    default:
      return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/notificationReducer.js